import React, { FunctionComponent } from 'react'

interface IPillProps {
  active?: boolean
}

const Pill: FunctionComponent<IPillProps> = ({ active = false, children }): JSX.Element => {
  return (
    <div
      className={`rounded-full border-primary-600 dark:border-primary-800 border-2 font-medium inline-block mr-2 my-1 px-6 py-1 ${
        active && 'bg-primary-300 dark:bg-primary-700'
      }`}
    >
      {children}
    </div>
  )
}

export default Pill
